import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgWarningIcon = (
  {
    title,
    titleId,
    desc,
    descId,
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 22 22"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#ECBF51"
      d="M10.992 2.655a2.5 2.5 0 0 1 2.173 1.265l6.665 11.663.078.145a2.5 2.5 0 0 1-2.24 3.605H4.332a2.5 2.5 0 0 1-2.181-3.747L8.818 3.92a2.5 2.5 0 0 1 2.174-1.265"
    />
    <path
      fill="#111"
      d="M12 16c0-.552-.445-1-.995-1h-.01A1 1 0 0 0 10 16c0 .552.445 1 .995 1h.01c.55 0 .995-.448.995-1M10 8v4c0 .552.445 1 .995 1 .549 0 .994-.448.994-1V8c0-.552-.445-1-.994-1A1 1 0 0 0 10 8"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgWarningIcon);
const Memo = memo(ForwardRef);
export default Memo;
